module.exports = __webpack_public_path__ + "9fa83a3811e40aebdd2f26b18acf8048.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/liv-erickson.jpg
 ** module id = 418
 ** module chunks = 0
 **/